import Cookies from 'js-cookie'
import { JSONError } from '../../../Errors/JsonError'

export default {
  data: function () {
    return {
      jsonStatus: '',
      jsonStatusText: '',
      jsonStatusObject: null,
      errorsInjected: [],
      unauthorized: false,
      currentRefreshTokenRequest: null,
    }
  },

  methods: {
    refreshTokenJWT() {
      // Error handling and such omitted here for simplicity.
      let xhr = new XMLHttpRequest()
      xhr.open('GET', config.host + 'refresh_token.php', false)

      return new Promise((resolve) => {
        xhr.send()
        if (xhr.status === 200) {
          this.$root.jwtToken = xhr.responseText
          this.currentRefreshTokenRequest = null
          resolve(true)
          return
        }

        resolve(false)
      })
    },

    redirectToLogin() {
      Cookies.set('redirect_url', document.location.href, { expires: 1, secure: true, sameSite: 'lax' })
      window.location.href = config.host + 'connexion.php'
    },

    getJSONHttpRequest(method, action) {
      let xhr = new XMLHttpRequest()

      let url
      try {
        url = new URL(action)
      } catch (error) {
        url = new URL(config.urlAPI + action)
      }

      xhr.open(method, url.toString(), true)
      xhr.responseType = 'json'
      xhr.setRequestHeader('Authorization', 'Bearer ' + this.$root.jwtToken)
      xhr.setRequestHeader('Accept', 'application/json')
      xhr.setRequestHeader('Accept-Language', this.$i18n.locale)

      if (config.switchUser) {
        xhr.setRequestHeader('X-Switch-User', config.switchUser)
      }

      return xhr
    },

    sendJSON(method, action, content, param) {
      if (param) {
        param = Object.assign({ displayError: true }, param)
      }

      let xhr = this.getJSONHttpRequest(method, action)
      let cancelled = false

      const promise = new Promise((resolve, reject) => {
        this.$root.jsonStatus = 'waiting'

        if (param && (param.waitingText || param.waitingTextT)) {
          this.$root.jsonStatusText = param.waitingTextT ? this.$t(param.waitingTextT) : param.waitingText
        } else {
          this.$root.jsonStatusText = this.$t('main.waiting')
        }

        if (param && !param.noWaitingModal) {
          this.$root.jsonStatus = 'waiting'
          $('#modal-waiting-text').modal({ backdrop: 'static', keyboard: false })
        }

        xhr.onreadystatechange = async () => {
          if (cancelled) {
            return
          }

          if (xhr.readyState === xhr.DONE) {
            if (xhr.status === 401) {
              if (this.unauthorized) {
                this.redirectToLogin()
              } else {
                this.unauthorized = true
                if (!this.$root.currentRefreshTokenRequest) {
                  this.$root.currentRefreshTokenRequest = this.refreshTokenJWT()
                }

                if (await this.$root.currentRefreshTokenRequest) {
                  await this.$nextTick(() => this.sendJSON(method, action, content, param).then(resolve, reject))
                  this.$root.currentRefreshTokenRequest = null
                } else {
                  this.redirectToLogin()
                }
              }
            } else {
              this.unauthorized = false
              if (xhr.status >= 200 && xhr.status < 300) {
                const isErrorAlreadyDisplayed = this.$root.jsonStatus === 'error'

                if (!isErrorAlreadyDisplayed) {
                  this.$root.jsonStatus = 'success'

                  if (param?.successTextT) {
                    this.$root.jsonStatusText = this.$t ? this.$t(param.successTextT) : ''
                  } else if (param?.successText) {
                    this.$root.jsonStatusText = param?.successText
                  } else {
                    this.$root.jsonStatusText = this.$t ? this.$t('main.success') : ''
                  }
                }

                resolve(xhr.response)

                if (param && !isErrorAlreadyDisplayed) {
                  if (this.$root.jsonStatusText && this.$root.toast) {
                    this.$root.toast(this.$root.jsonStatusText)
                  }
                  $('#modal-waiting-text').modal('hide')
                }
              } else {
                let reason = new JSONError(
                  xhr.response,
                  `sendJSON: \`${method} ${action}\` failed with status: [${xhr.status}]`,
                  null,
                  null,
                  xhr.status,
                )

                if (param && !param.displayError) {
                  reject(reason)
                  return
                }
                this.$root.jsonStatus = 'error'
                if (xhr.response?.code) {
                  this.$root.jsonStatusText = this.$root.$t(String(xhr.response.code))
                } else if (xhr.response?.detail) {
                  this.$root.jsonStatusText = this.$t ? this.$t(xhr.response.detail) : ''
                } else {
                  this.$root.jsonStatusText = this.$t ? this.$t('main.error') : ''
                }

                if (param && (param.errorTextT || param.errorText)) {
                  if (param.errorTextT) {
                    this.$root.jsonStatusText = this.$t ? this.$t(param.errorTextT) : ''
                  } else {
                    this.$root.jsonStatusText = param.errorText
                  }
                } else if (xhr.response?.errors) {
                  this.$root.jsonStatusText = this.$te(xhr.response.message?.title)
                    ? this.$t(xhr.response.message?.title)
                    : (xhr.response.message?.title ?? xhr.response.message)
                  this.$root.jsonStatusObject = xhr.response.details
                    ? { details: [...xhr.response.details] }
                    : xhr.response.errors
                } else {
                  let errors = reason.getResponseErrors()
                  if (errors?.length > 0) {
                    this.$root.jsonStatusText = `${this.$t('main.errorHeader', { count: errors.length })}<ul>`
                    this.$root.jsonStatusText += errors.map((err) => `<li>${err}</li>`).join('')
                    this.$root.jsonStatusText += '</ul>'
                  }
                }

                $('#modal-waiting-text').modal({ backdrop: 'static', keyboard: false })
                reject(reason)
              }
            }
          }
        }

        if (content) {
          if (typeof content !== 'string') {
            content = JSON.stringify(content)
          }
          xhr.setRequestHeader('Content-Type', 'application/json')
          xhr.send(content)
        } else {
          xhr.send()
        }
      })

      promise.cancel = () => {
        cancelled = true
        xhr.abort()
      }
      return promise
    },

    /**
     * Call Http : GET action with param
     *
     * @param action url to call
     * @param param to distplay popin : { waitingText: 'text to display', waitingTextT: 'key for i18n text to display',
     *                                    successText: 'text for success', successTextT: 'key for i18n text for success',
     *                                    errorText: 'text for error', errorTextT: 'key for i18n text for error',
     *                                  }
     * @returns {Promise<unknown>}
     */
    getJSON(action, param) {
      return this.sendJSON('GET', action, false, param)
    },

    /**
     * Call Http : POST action with param
     *
     * @param action url to call
     * @param content to POST
     * @param param to distplay popin : { waitingText: 'text to display', waitingTextT: 'key for i18n text to display',
     *                                    successText: 'text for success', successTextT: 'key for i18n text for success',
     *                                    errorText: 'text for error', errorTextT: 'key for i18n text for error',
     *                                  }
     * @returns {Promise<unknown>}
     */
    postJSON(action, content, param) {
      return this.sendJSON('POST', action, content, param)
    },

    /**
     * Call Http : PUT action with param
     *
     * @param action url to call
     * @param content to PUT
     * @param param to distplay popin : { waitingText: 'text to display', waitingTextT: 'key for i18n text to display',
     *                                    successText: 'text for success', successTextT: 'key for i18n text for success',
     *                                    errorText: 'text for error', errorTextT: 'key for i18n text for error',
     *                                  }
     * @returns {Promise<unknown>}
     */
    putJSON(action, content, param) {
      return this.sendJSON('PUT', action, content, param)
    },

    /**
     * Call Http : PATCH action with param
     *
     * @param action url to call
     * @param content to PATCH
     * @param param to distplay popin : { waitingText: 'text to display', waitingTextT: 'key for i18n text to display',
     *                                    successText: 'text for success', successTextT: 'key for i18n text for success',
     *                                    errorText: 'text for error', errorTextT: 'key for i18n text for error',
     *                                  }
     * @returns {Promise<unknown>}
     */
    patchJSON(action, content, param) {
      return this.sendJSON('PATCH', action, content, param)
    },

    /**
     * Call Http : DELETE action with param
     *
     * @param action url to call
     * @param content to DELETE
     * @param param to distplay popin : { waitingText: 'text to display', waitingTextT: 'key for i18n text to display',
     *                                    successText: 'text for success', successTextT: 'key for i18n text for success',
     *                                    errorText: 'text for error', errorTextT: 'key for i18n text for error',
     *                                  }
     * @returns {Promise<unknown>}
     */
    deleteJSON(action, content, param) {
      return this.sendJSON('DELETE', action, content, param)
    },

    async getFile(path) {
      let myHeaders = new Headers()
      myHeaders.append('Authorization', `Bearer ${config.token}`)
      myHeaders.append('Accept-Language', this.$i18n.locale)

      const url = config.urlAPI + path
      const response = await fetch(url, {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
      })

      if (!response.ok) {
        throw new JSONError(
          response,
          `GET ${path} failed with status: [${response.status}]`,
          null,
          null,
          response.status,
        )
      }

      return await response.blob()
    },
  },
}
